module.exports = __webpack_public_path__ + "static/media/sm.72b5ecf2.png";